(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/marketplace/components/common/assets/javascripts/game-selector.js') >= 0) return;  svs.modules.push('/modules/marketplace/components/common/assets/javascripts/game-selector.js');

'use strict';

const {
  useMediaQuery,
  breakpoints,
  BREAKPOINT_AM
} = svs.components.lbUtils.useMediaQuery;
const {
  getProductBrand
} = svs.components.lbUtils.brandMapping.fn;
const {
  BOMBEN,
  CHALLENGE,
  EUROPATIPSET,
  POWERPLAY,
  STRYKTIPSET,
  T8
} = svs.utils.products.productIds;
const {
  getClassName
} = svs.components.lbUtils.sportProducts;
const {
  ReactBrand: Brand,
  ReactPaper: Paper
} = svs.ui;
const GameSelector = () => {
  const size = useMediaQuery(breakpoints.down(BREAKPOINT_AM)) ? 100 : 150;
  const products = [STRYKTIPSET, EUROPATIPSET, T8, POWERPLAY, CHALLENGE, BOMBEN];
  const renderBrands = () => products.map(productId => {
    const brand = getClassName(productId);
    return React.createElement("li", {
      key: brand,
      role: "listitem"
    }, React.createElement(Brand, {
      brand: brand,
      size: size,
      square: true
    }));
  });
  return React.createElement("div", {
    className: "marketplace-welcome-wrap"
  }, React.createElement(Paper, {
    branding: "sport"
  }, React.createElement("div", {
    className: "paper-rows"
  }, React.createElement("h2", {
    className: "f-600 f-bold margin-bottom-0"
  }, "V\xE4lj mellan sex olika spel"), React.createElement("ul", {
    className: "marketplace-brands"
  }, renderBrands()))));
};
setGlobal('svs.marketplace.components.common.GameSelector', GameSelector);

 })(window);